import { render, staticRenderFns } from "./ViewBase.vue?vue&type=template&id=3f80dd5c&scoped=true"
import script from "./ViewBase.vue?vue&type=script&lang=js"
export * from "./ViewBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f80dd5c",
  null
  
)

export default component.exports